function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GET_GOALMENTIONLISTITEMSBYGOALMENTIONGOALIDANDAUTHUSERID_REQUEST = "GET_GOALMENTIONLISTITEMSBYGOALMENTIONGOALIDANDAUTHUSERID_REQUEST";
export var GET_GOALMENTIONLISTITEMSBYGOALMENTIONGOALIDANDAUTHUSERID_SUCCESS = "GET_GOALMENTIONLISTITEMSBYGOALMENTIONGOALIDANDAUTHUSERID_SUCCESS";
export var GET_GOALMENTIONLISTITEMSBYGOALMENTIONGOALIDANDAUTHUSERID_FAILURE = "GET_GOALMENTIONLISTITEMSBYGOALMENTIONGOALIDANDAUTHUSERID_FAILURE";
export var RESET_GET_GOALMENTIONLISTITEMSBYGOALMENTIONGOALIDANDAUTHUSERID = "RESET_GET_GOALMENTIONLISTITEMSBYGOALMENTIONGOALIDANDAUTHUSERID";
export var fetchGoalMentionListItemsByGoalMentionGoalIdAndAuthUserId = function fetchGoalMentionListItemsByGoalMentionGoalIdAndAuthUserId(goalMentionGoalId, timeZoneName, authUserId, maxId, sinceId, count) {
  var queryString = urlSearchParams({
    goalMentionGoalId: goalMentionGoalId,
    timeZoneName: timeZoneName,
    authUserId: authUserId,
    maxId: maxId,
    sinceId: sinceId,
    count: count
  });
  return _defineProperty({
    goalMentionGoalId: goalMentionGoalId,
    timeZoneName: timeZoneName,
    authUserId: authUserId,
    maxId: maxId,
    sinceId: sinceId,
    count: count
  }, CALL_API, {
    types: [GET_GOALMENTIONLISTITEMSBYGOALMENTIONGOALIDANDAUTHUSERID_REQUEST, GET_GOALMENTIONLISTITEMSBYGOALMENTIONGOALIDANDAUTHUSERID_SUCCESS, GET_GOALMENTIONLISTITEMSBYGOALMENTIONGOALIDANDAUTHUSERID_FAILURE],
    endpoint: "goalMentionListItems/search/findByGoalMentionGoalIdAndAuthUserId".concat(queryString),
    init: {
      credentials: "same-origin"
    }
  });
};